import React, { Fragment, useCallback, useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { Button, Card, CardBody, CardTitle, Col, FormGroup, Label, Row, Input } from "reactstrap";
import { AvCheckbox, AvCheckboxGroup, AvForm } from "availity-reactstrap-validation";
import { Link } from "react-router-dom";

import formsValidators, {
  requiredIfOtherExist,
} from "../../validators/form.validators";
import useDropzoneFacade from "../../hooks/useDropzoneFacade";
import useAvForm from "../../hooks/useAvForm";
import FormGroupText from "./inputs/FormGroupText";
import WYSISYGComponent from "./inputs/WYSISYGComponent";
import FormGroupReactSelect from "./inputs/FormGroupReactSelect";
import noop from "../../helpers/noop";
import useMountedState from "../../hooks/useMountedState";
import FormGroupImages from "./inputs/FormGroupImages";
import InputWithReadOnlyTextPart from "./inputs/InputWithReadOnlyTextPart";
import getReadOnlyUrlPart from "../../helpers/getReadOnlyUrlPart";

import styles from "./forms.module.scss";
import FormGroupMultiSelect from './inputs/FormGroupMultiSelect';
import { MAX_TAG_LENGTH } from '../../constants/leghtValidity';
import { VALUE_FIELD_ID } from '../../constants/selectConstants';
import parseInteger from '../../helpers/parseInteger';
import { REDEMPTION_CODE_SOURCES_RADIO, REDEMPTION_CODE_TYPES_RADIO } from '../../constants/rewards';
// import { changeTypeHandler } from '../../helpers/rewards';
import classNames from "classnames";
import { getCoursesForRewardOption } from '../../store/dashboard/Rewards/actions';

const currencies = ["EUR", "USD", "GBP", "NZD", "AUD", "CAD", "INR"];
const applicableToSubscriptionValue = 'ApplicableToSubscription';
const hiddenValue = 'Hidden';
const redeemableValue = 'Redeemable';
const subscriptionConstraintValue = 'SubscriptionConstraint';
const courseConstraintValue = 'CourseConstraint';



const SaveReward = ({
  model,
  saveRewardFunc,
  rewards,
  getCoursesForRewardOption,
  updateDirtyState = noop,
}) => {
  
  const [redemptionCodeSource, setRedemptionCodeSource] = useState("");
  const [redemptionCodeType, setRedemptionCodeType] = useState("");
  const [isRedemptionCodeSourceChanged, setIsRedemptionCodeSourceChanged] = useState(false);
  const [isRedemptionCodeTypeChanged, setIsRedemptionCodeTypeChanged] = useState(false);

  const initialState = {
    title: "",
    subTitle: "",
    description: "",
    benefitDescription: "",
    firstButtonText: "",
    firstButtonLink: "",
    secondButtonText: "",
    secondButtonLink: "",
    ordinalNumber: "",
    hidden: [],
    redeemable: [],
    subscriptionConstraint: [],
    courseConstraint: [],
  };
  const [formData, updateFormData] = useState(initialState);
  const [initialFile, updateInitialFile] = useMountedState(null);
  const [initialCompanyLogoFile, updateInitialCompanyLogoFile] = useMountedState(null);
  const { loading, dataCoursesForRewardOption: coursesData } = rewards;

  useEffect(() => {
    getCoursesForRewardOption({});    
  }, []);

  const [ready, updateReadyState] = useMountedState(false);
  const [formRef, hasFormError, handleFormChange, isDirty, values] =
    useAvForm();
    const [
      error,
      selectedFiles,
      handleAcceptedFiles,
      setSelectedFiles,
    ] = useDropzoneFacade();


     const [
      errorCompanyLogo,
      selectedCompanyLogoFiles,
      handleAcceptedCompanyLogoFiles,
      setSelectedCompanyLogoFiles,
    ] = useDropzoneFacade();
  const changeRedemptionCodeSourceHandler = useCallback(
    (event) => {
      
      setRedemptionCodeSource(event.target.value);
      handleFormChange();
      setIsRedemptionCodeSourceChanged(true);
    },
    [handleFormChange]
  );
  const changeRedemptionCodeTypeHandler = useCallback(
    (event) => {
      setRedemptionCodeType(event.target.value);
      handleFormChange();
      setIsRedemptionCodeTypeChanged(true);
    },
    [handleFormChange]
  );


  // console.log('Courses: ', model.courses);

  const handleFormSubmit = (event, values) => {
    const {
      title,
      subTitle,
      description,
      benefitDescription,
      firstButtonText,
      firstButtonLink,
      secondButtonText,
      secondButtonLink,
      hidden,
      redeemable,
      subscriptionConstraint,
      courseConstraint,
      ordinalNumber,
      courses,
    } = values;
    const model = {
      title,
      subTitle,
      description,
      benefitDescription,
      firstButtonText: firstButtonText === "" ? null : firstButtonText,
      firstButtonLink: firstButtonLink === "" ? null : firstButtonLink,
      secondButtonText: secondButtonText === "" ? null : secondButtonText,
      secondButtonLink: secondButtonLink === "" ? null : secondButtonLink,
      ordinalNumber: ordinalNumber === "" ? null : parseInteger(ordinalNumber),
      isHidden: hidden.length === 1,
      isRedeemable: redeemable.length === 1,
      toApplySubscriptionConstraint: subscriptionConstraint.length === 1,
      toApplyCourseConstraint: courseConstraint.length === 1,
      redemptionCodeSource: redemptionCodeSource ? redemptionCodeSource : null,
      redemptionCodeType: redemptionCodeType ? redemptionCodeType : null,
      courseIds: courses,
    };
  
    if (initialFile !== selectedFiles[0]) {
      model.files = selectedFiles;
    }

    if (initialCompanyLogoFile !== selectedCompanyLogoFiles[0]) {
      model.companyLogoFiles = selectedCompanyLogoFiles;
    }

    saveRewardFunc(model);
  };

  const pageTitle = useMemo(
    () => (model ? "Edit reward" : "Create reward"),
    [model]
  );
  const btnSaveLabel = useMemo(
    () => (model ? "Save" : "Create"),
    [model]
  );
  const disableState = useMemo(
    () =>
      !(
        isDirty ||
        initialFile !== selectedFiles[0] ||
        initialCompanyLogoFile !== selectedCompanyLogoFiles[0] ||
        isRedemptionCodeSourceChanged ||
        isRedemptionCodeTypeChanged
      ) ||
      loading ||
      !selectedFiles.length ||
      !selectedCompanyLogoFiles.length ||
      hasFormError,
    [
      loading,
      selectedFiles,
      hasFormError,
      isDirty,
      initialFile,
      selectedCompanyLogoFiles,
      initialCompanyLogoFile,
      model,
      isRedemptionCodeSourceChanged,
      isRedemptionCodeTypeChanged
    ]
  );

  useEffect(() => {
    updateDirtyState(isDirty);
  }, [isDirty]);

  useEffect(() => {
    if (!!model) {
      const {
        title,
        subTitle,
        description,
        benefitDescription,
        firstButtonText,
        firstButtonLink,
        secondButtonText,
        secondButtonLink,
        initialFile,
        initialCompanyLogoFile,
        isHidden,
        isRedeemable,
        toApplySubscriptionConstraint,
        toApplyCourseConstraint,
        ordinalNumber,
        redemptionCodeSource,
        redemptionCodeType,
        courses,
      } = model;
      const formData = {
        ...initialState,
        title,
        subTitle,
        description,
        benefitDescription,
        firstButtonText,
        firstButtonLink,
        secondButtonText,
        secondButtonLink,
        hidden: isHidden ? [hiddenValue] : [],
        redeemable: isRedeemable ? [redeemableValue] : [],
        subscriptionConstraint: toApplySubscriptionConstraint ? [subscriptionConstraintValue] : [],
        courseConstraint: toApplyCourseConstraint ? [courseConstraintValue] : [],
        ordinalNumber: ordinalNumber ? ordinalNumber : '',
        courses,
        
      };

      if (initialFile) {
        updateInitialFile(initialFile);
        handleAcceptedFiles([initialFile], []);
      }

      if (initialCompanyLogoFile) {
        updateInitialCompanyLogoFile(initialCompanyLogoFile);
        handleAcceptedCompanyLogoFiles([initialCompanyLogoFile], []);
      }

      updateFormData(formData);
      setRedemptionCodeSource(redemptionCodeSource ? redemptionCodeSource : "");
      setRedemptionCodeType(redemptionCodeType ? redemptionCodeType : "");
    }

    updateReadyState(true);
  }, [model]);

  useEffect(() => {
    if (ready && selectedFiles.length === 0 && initialFile) {
      setSelectedFiles([initialFile]);
    }
  }, [selectedFiles]);

  useEffect(() => {
    if (ready && selectedCompanyLogoFiles.length === 0 && initialCompanyLogoFile) {
      setSelectedCompanyLogoFiles([initialCompanyLogoFile]);
    }
  }, [selectedCompanyLogoFiles]);

  const getCoursesValue = useMemo(() => {
    if (!!model) {
      return model.courses?.map(({ id, title }) => {
        return {
          id: id,
          name: title,
        }
      });
    }
  }, [model]);

  return (
    ready && (
      <>
        <AvForm
          onValidSubmit={handleFormSubmit}
          ref={formRef}
          model={formData}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.preventDefault();
              return false;
            }
          }}
        >
          <Card>
            <CardBody>
              <CardTitle className="mb-4">{pageTitle}</CardTitle>
              <FormGroupText
                name={`ordinalNumber`}
                label="Ordinal Number"
                placeholder="Enter Ordinal Number"
                handleFormChange={handleFormChange}
                validator={formsValidators.reward.ordinalNumber}
              />
              <FormGroupText
                name="title"
                label="Reward Name"
                placeholder="Enter reward Name"
                validator={formsValidators.reward.title}
                handleFormChange={handleFormChange}
              />
               <FormGroupText
                name="subTitle"
                label="Reward Title"
                placeholder="Enter reward title"
                validator={formsValidators.reward.subTitle}
                handleFormChange={handleFormChange}
              />
              
              <FormGroupImages
                multiple={false}
                label="Reward Header Image"
                error={error}
                selectedImages={selectedFiles}
                initialFile={initialFile}
                handleAcceptedImages={handleAcceptedFiles}
                setSelectedImages={setSelectedFiles}
             />

             <FormGroupImages
                multiple={false}
                label="Reward Company Logo Image"
                error={errorCompanyLogo}
                selectedImages={selectedCompanyLogoFiles}
                initialFile={initialCompanyLogoFile}
                handleAcceptedImages={handleAcceptedCompanyLogoFiles}
                setSelectedImages={setSelectedCompanyLogoFiles}
             />
              <CardTitle className="mb-4">Reward info</CardTitle>
              <WYSISYGComponent
                name="description"
                label="Reward Copy"
                validator={formsValidators.reward.description}
                handleFormChange={handleFormChange}
              />
              <WYSISYGComponent
                name="benefitDescription"
                label="Benefit Copy"
                validator={formsValidators.reward.benefitDescription}
                handleFormChange={handleFormChange}
              />

              
              <CardTitle className="mb-4">Reward Button Info</CardTitle>
              <FormGroupText
                name="firstButtonText"
                label="First Button Text"
                placeholder="Enter First Button Text"
                // validator={formsValidators.reward.firstButtonText}
                handleFormChange={handleFormChange}
              />
              <FormGroupText
                name="firstButtonLink"
                label="First Button Link"
                placeholder="Enter First Button Link"
                // validator={formsValidators.reward.firstButtonLink}
                handleFormChange={handleFormChange}
              />
              <FormGroupText
                name="secondButtonText"
                label="Second Button Text"
                placeholder="Enter Second Button Text"
                handleFormChange={handleFormChange}
              />
              <FormGroupText
                name="secondButtonLink"
                label="Second Button Link"
                placeholder="Enter Second Button Link"
                handleFormChange={handleFormChange}
              />
              <FormGroup className='mb-4' row>
                <Col lg={2}>
                  <Label>Is Hidden</Label>
                </Col>
                <Col lg={10}>
                <AvCheckboxGroup className='' name={'hidden'}>
                  <AvCheckbox
                    onChange={handleFormChange}
                    className="cursor-pointer"
                    customInput
                    label="Is Hidden"
                    value={hiddenValue}
                  />
                  </AvCheckboxGroup>
                </Col>
              
              </FormGroup>
              <FormGroup className='mb-4' row>
                <Col lg={2}>
                  <Label>Is Redeemable</Label>
                </Col>
                <Col lg={10}>
                <AvCheckboxGroup className='' name={'redeemable'}>
                  <AvCheckbox
                    onChange={handleFormChange}
                    className="cursor-pointer"
                    customInput
                    label="Is Redeemable"
                    value={redeemableValue}
                  />
                  </AvCheckboxGroup>
                </Col>
              </FormGroup>
              <FormGroup className="custom-control custom-radio mt-4 mb-3 d-flex pl-0" row>
              <Col lg={2}>
                <Label>Redemption Code Source</Label>
              </Col>
              <Col lg={10} className='d-flex flex-row pl-5'>
                {REDEMPTION_CODE_SOURCES_RADIO.map(({ label, value }, index) => (
                  <FormGroup
                    className={classNames(
                      "mb-0",
                      index !== REDEMPTION_CODE_SOURCES_RADIO.length - 1 && "mr-5"
                    )}
                    key={`redemption-code-source-radio-${index}`}
                  >
                    <Input
                      type="radio"
                      id={`redemption-code-source-radio-${index}`}
                      name="redemptionCodeSource"
                      className="custom-control-input"
                      onChange={changeRedemptionCodeSourceHandler}
                      value={value}
                      checked={redemptionCodeSource === value}
                    />
                    <Label
                      className="custom-control-label"
                      htmlFor={`redemption-code-source-radio-${index}`}
                    >
                      {label}
                    </Label>
                  </FormGroup>
                ))}
              
              </Col>
              
            </FormGroup>
            <FormGroup className="custom-control custom-radio mt-4 mb-3 d-flex pl-0" row>
              <Col lg={2}>
                <Label>Redemption Code Type</Label>
              </Col>
              <Col lg={10} className='d-flex flex-row pl-5'>
                {REDEMPTION_CODE_TYPES_RADIO.map(({ label, value }, index) => (
                  <FormGroup
                    className={classNames(
                      "mb-0",
                      index !== REDEMPTION_CODE_TYPES_RADIO.length - 1 && "mr-5"
                    )}
                    key={`redemption-code-type-radio-${index}`}
                  >
                    <Input
                      type="radio"
                      id={`redemption-code-type-radio-${index}`}
                      name="redemptionCodeType"
                      className="custom-control-input"
                      onChange={changeRedemptionCodeTypeHandler}
                      value={value}
                      checked={redemptionCodeType === value}
                    />
                    <Label
                      className="custom-control-label"
                      htmlFor={`redemption-code-type-radio-${index}`}
                    >
                      {label}
                    </Label>
                  </FormGroup>
                ))}
              
              </Col>
              
            </FormGroup>
              <FormGroup className='mb-4' row>
                <Col lg={2}>
                  <Label>To Apply Subscription Constraint</Label>
                </Col>
                <Col lg={10}>
                <AvCheckboxGroup className='' name={'subscriptionConstraint'}>
                  <AvCheckbox
                    onChange={handleFormChange}
                    className="cursor-pointer"
                    customInput
                    label="To Apply Subscription Constraint"
                    value={subscriptionConstraintValue}
                  />
                  </AvCheckboxGroup>
                </Col>
              </FormGroup>
              <FormGroup className='mb-4' row>
                <Col lg={2}>
                  <Label>To Apply Course Constraint</Label>
                </Col>
                <Col lg={10}>
                <AvCheckboxGroup className='' name={'courseConstraint'}>
                  <AvCheckbox
                    onChange={handleFormChange}
                    className="cursor-pointer"
                    customInput
                    label="To Apply Course Constraint"
                    value={courseConstraintValue}
                  />
                  </AvCheckboxGroup>
                </Col>
              </FormGroup>

              <FormGroupMultiSelect
                name="courses"
                allowCreate={false}
                label="Courses"
                placeholder="Select courses"
                value={getCoursesValue}
                options={coursesData.map(({ id, title }) => ({
                  id: id,
                  name: title,
                }))}
                validator={formsValidators.reward.courses}
                handleFormChange={handleFormChange}
                formState={formData}
                updateFormState={updateFormData}
                maxCreateLength={MAX_TAG_LENGTH}
                isMulti
                optionValueName={VALUE_FIELD_ID}
            />

            </CardBody>
          </Card>
          <Row className="justify-content-end">
            <Col xs="12">
              <Link
                to={`/rewards`}
              >
                <Button color="secondary" className="mr-2">
                  Cancel
                </Button>
              </Link>
              <Button
                type="submit"
                color="primary"
                disabled={disableState}
                className={styles.btnSave}
              >
                {btnSaveLabel}
              </Button>
            </Col>
          </Row>
        </AvForm>
      </>
    )
  );
};

const mapStateToProps = ({ Rewards }) => {
  return {
    rewards: Rewards,
  };
};

export default connect(mapStateToProps, {
  getCoursesForRewardOption
 })(SaveReward);
